<template>
    <div>
        <ResetPassword
            ref="resetPassword"
            @modelChanged="$emit('modelChanged', $event)"
        />
    </div>
</template>

<script>
import ResetPassword from './ResetPassword'

export default {
    components: {
        ResetPassword,
    },

    methods: {
        async resetPassword(model) {
            await this.$refs.resetPassword.open(model)
        },
    },
}
</script>

<style></style>
